import { Action, createReducer, on } from '@ngrx/store';
import { ICourierActivitiesState } from './courier-activities';
import { IResponseRetrieveBolla } from '../../interfaces/response-retrieve-bolla';
import { RETRIEVE_ACQUISISCI_BOLLA_SUCCESS, RETRIEVE_ANNULLA_BOLLA_SUCCESS, RETRIEVE_BOLLA_POST_NO_PALMARE_SUCCESS, RETRIEVE_BOLLA_POST_SUCCESS, RETRIEVE_BOLLA_SUCCESS, RETRIEVE_CONSEGNA_SENZA_PALMARE_SUCCESS, RETRIEVE_MAGAZZINO_CONTATORI_SUCCESS, RETRIEVE_MAGAZZINO_PICKUP_DELETE_SUCCESS, RETRIEVE_MAGAZZINO_PICKUP_SUCCESS, RETRIEVE_STAMPA_SCONTRINO_RITIRO_SUCCESS } from './courier-activities.actions';
import { IResponseMagazzinoPickup } from '../../interfaces/response-magazzino-pickup';
import { IBollaPostResponse } from '../../interfaces/bolla-post';
import { IMagazzinoContatoriResponse } from '../../interfaces/magazzino-contatori';
import { IStampaScontrinoRitiroResponse } from '../../interfaces/stampa-scontrino-ritiro';
import { IAcquisisciBollaResponse, IAnnullaBolla } from '../../interfaces/acquisisci-bolla';


/* INITIAL STATE */
const initialState: ICourierActivitiesState = {
  responseRetrieveBolla: null,
  responseMagazzinoPickup: null,
  responseRetrieveBollaPost: null,
  responseMagazzinoContatori:  null,
  responseStampaScontrinoRitiro: null,
  responseAcquisisciBolla: null,
  responseBollaPostNoPalmare: null,
  responseDeleteMagazzinoPickup: null,
  responseAnnullaBolla: null,
  responseConsegnaSenzaPalmare: null,
};

const handleSetRetrieveBolla = (
  state: ICourierActivitiesState,
  { responseRetrieveBolla }: { responseRetrieveBolla: IResponseRetrieveBolla | null }
): ICourierActivitiesState => {
  return {
    ...state,
    responseRetrieveBolla,
  };
};

const handleMagazzinoPickup = (
  state: ICourierActivitiesState,
  { responseMagazzinoPickup }: { responseMagazzinoPickup: IResponseMagazzinoPickup | null }
): ICourierActivitiesState => {
  return {
    ...state,
    responseMagazzinoPickup,
  };
};

const handleBollaPost = (
  state: ICourierActivitiesState,
  { responseRetrieveBollaPost }: { responseRetrieveBollaPost: IBollaPostResponse | null }
): ICourierActivitiesState => {
  return {
    ...state,
    responseRetrieveBollaPost,
  };
};

const handleMagazzinoContatori = (
  state: ICourierActivitiesState,
  { responseMagazzinoContatori }: { responseMagazzinoContatori: IMagazzinoContatoriResponse | null }
): ICourierActivitiesState => {
  return {
    ...state,
    responseMagazzinoContatori,
  };
};

const handleStampaScontrinoRitiro = (
  state: ICourierActivitiesState,
  { responseStampaScontrinoRitiro }: { responseStampaScontrinoRitiro: IStampaScontrinoRitiroResponse | null }
): ICourierActivitiesState => {
  return {
    ...state,
    responseStampaScontrinoRitiro,
  };
};

const handleAcquisisciBolla = (
  state: ICourierActivitiesState,
  { responseAcquisisciBolla }: { responseAcquisisciBolla: IAcquisisciBollaResponse | null }
): ICourierActivitiesState => {
  return {
    ...state,
    responseAcquisisciBolla,
  };
};

const handleBollaPostNoPalmare = (
  state: ICourierActivitiesState,
  { responseBollaPostNoPalmare }: { responseBollaPostNoPalmare: IBollaPostResponse | null }
): ICourierActivitiesState => {
  return {
    ...state,
    responseBollaPostNoPalmare,
  };
};

const handleMagazzinoPickupDelete = (
  state: ICourierActivitiesState,
  { responseDeleteMagazzinoPickup }: { responseDeleteMagazzinoPickup: IResponseMagazzinoPickup | null }
): ICourierActivitiesState => {
  return {
    ...state,
    responseDeleteMagazzinoPickup,
  };
};

const handleAnnullaBolla = (
  state: ICourierActivitiesState,
  { responseAnnullaBolla }: { responseAnnullaBolla: IAnnullaBolla | null }
): ICourierActivitiesState => {
  return {
    ...state,
    responseAnnullaBolla,
  };
};

const handleConsegnaSenzaPalmare = (
  state: ICourierActivitiesState,
  { responseConsegnaSenzaPalmare }: { responseConsegnaSenzaPalmare: IAnnullaBolla | null }
): ICourierActivitiesState => {
  return {
    ...state,
    responseConsegnaSenzaPalmare,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(RETRIEVE_BOLLA_SUCCESS, handleSetRetrieveBolla),
  on(RETRIEVE_MAGAZZINO_PICKUP_SUCCESS, handleMagazzinoPickup),
  on(RETRIEVE_BOLLA_POST_SUCCESS, handleBollaPost),
  on(RETRIEVE_MAGAZZINO_CONTATORI_SUCCESS, handleMagazzinoContatori),
  on(RETRIEVE_STAMPA_SCONTRINO_RITIRO_SUCCESS, handleStampaScontrinoRitiro),
  on(RETRIEVE_ACQUISISCI_BOLLA_SUCCESS, handleAcquisisciBolla),
  on(RETRIEVE_BOLLA_POST_NO_PALMARE_SUCCESS, handleBollaPostNoPalmare),
  on(RETRIEVE_MAGAZZINO_PICKUP_DELETE_SUCCESS, handleMagazzinoPickupDelete),
  on(RETRIEVE_ANNULLA_BOLLA_SUCCESS, handleAnnullaBolla),
  on(RETRIEVE_CONSEGNA_SENZA_PALMARE_SUCCESS, handleConsegnaSenzaPalmare),
);

export const courierActivitiesReducer = (
  state: ICourierActivitiesState | undefined,
  action: Action
): ICourierActivitiesState => reducer(state, action);
